export const countries = [
    { name: "Afghanistan", code: "AF", persianName: "افغانستان" },
    { name: "Albania", code: "AL", persianName: "آلبانی" },
    { name: "Algeria", code: "DZ", persianName: "الجزایر" },
    { name: "Andorra", code: "AD", persianName: "آندورا" },
    { name: "Angola", code: "AO", persianName: "آنگولا" },
    { name: "Antigua and Barbuda", code: "AG", persianName: "آنتیگوا و باربودا" },
    { name: "Argentina", code: "AR", persianName: "آرژانتین" },
    { name: "Armenia", code: "AM", persianName: "ارمنستان" },
    { name: "Australia", code: "AU", persianName: "استرالیا" },
    { name: "Austria", code: "AT", persianName: "اتریش" },
    { name: "Azerbaijan", code: "AZ", persianName: "آذربایجان" },
    { name: "Bahamas", code: "BS", persianName: "باهاما" },
    { name: "Bahrain", code: "BH", persianName: "بحرین" },
    { name: "Bangladesh", code: "BD", persianName: "بنگلادش" },
    { name: "Barbados", code: "BB", persianName: "باربادوس" },
    { name: "Belarus", code: "BY", persianName: "بلاروس" },
    { name: "Belgium", code: "BE", persianName: "بلژیک" },
    { name: "Belize", code: "BZ", persianName: "بلیز" },
    { name: "Benin", code: "BJ", persianName: "بنین" },
    { name: "Bhutan", code: "BT", persianName: "بوتان" },
    { name: "Bolivia", code: "BO", persianName: "بولیوی" },
    { name: "Bosnia and Herzegovina", code: "BA", persianName: "بوسنی و هرزگوین" },
    { name: "Botswana", code: "BW", persianName: "بوتسوانا" },
    { name: "Brazil", code: "BR", persianName: "برزیل" },
    { name: "Brunei", code: "BN", persianName: "برونئی" },
    { name: "Bulgaria", code: "BG", persianName: "بلغارستان" },
    { name: "Burkina Faso", code: "BF", persianName: "بورکینافاسو" },
    { name: "Burundi", code: "BI", persianName: "بوروندی" },
    { name: "Cabo Verde", code: "CV", persianName: "کیپ ورد" },
    { name: "Cambodia", code: "KH", persianName: "کامبوج" },
    { name: "Cameroon", code: "CM", persianName: "کامرون" },
    { name: "Canada", code: "CA", persianName: "کانادا" },
    {
      name: "Central African Republic",
      code: "CF",
      persianName: "جمهوری آفریقای مرکزی",
    },
    { name: "Chad", code: "TD", persianName: "چاد" },
    { name: "Chile", code: "CL", persianName: "شیلی" },
    { name: "China", code: "CN", persianName: "چین" },
    { name: "Colombia", code: "CO", persianName: "کلمبیا" },
    { name: "Comoros", code: "KM", persianName: "کومور" },
    {
      name: "Congo (Brazzaville)",
      code: "CG",
      persianName: "کنگو (برازاویل)",
    },
    {
      name: "Congo (Kinshasa)",
      code: "CD",
      persianName: "کنگو (کینشاسا)",
    },
    { name: "Costa Rica", code: "CR", persianName: "کاستاریکا" },
    { name: "Croatia", code: "HR", persianName: "کرواسی" },
    { name: "Cuba", code: "CU", persianName: "کوبا" },
    { name: "Cyprus", code: "CY", persianName: "قبرس" },
    { name: "Czechia", code: "CZ", persianName: "جمهوری چک" },
    { name: "Denmark", code: "DK", persianName: "دانمارک" },
    { name: "Djibouti", code: "DJ", persianName: "جیبوتی" },
    { name: "Dominica", code: "DM", persianName: "دومینیکا" },
    {
      name: "Dominican Republic",
      code: "DO",
      persianName: "جمهوری دومینیکن",
    },
    { name: "Ecuador", code: "EC", persianName: "اکوادور" },
    { name: "Egypt", code: "EG", persianName: "مصر" },
    { name: "El Salvador", code: "SV", persianName: "السالوادور" },
    {
      name: "Equatorial Guinea",
      code: "GQ",
      persianName: "گینه استوایی",
    },
    { name: "Eritrea", code: "ER", persianName: "اریتره" },
    { name: "Estonia", code: "EE", persianName: "استونی" },
    { name: "Eswatini", code: "SZ", persianName: "اسواتینی" },
    { name: "Ethiopia", code: "ET", persianName: "ایتوپیا" },
    { name: "Fiji", code: "FJ", persianName: "فیجی" },
    { name: "Finland", code: "FI", persianName: "فنلاند" },
    { name: "France", code: "FR", persianName: "فرانسه" },
    { name: "Gabon", code: "GA", persianName: "گابن" },
    { name: "Gambia", code: "GM", persianName: "گامبیا" },
    { name: "Georgia", code: "GE", persianName: "گرجستان" },
    { name: "Germany", code: "DE", persianName: "آلمان" },
    { name: "Ghana", code: "GH", persianName: "غنا" },
    { name: "Greece", code: "GR", persianName: "یونان" },
    { name: "Grenada", code: "GD", persianName: "گرنادا" },
    { name: "Guatemala", code: "GT", persianName: "گواتمالا" },
    { name: "Guinea", code: "GN", persianName: "گینه" },
    {
      name: "Guinea-Bissau",
      code: "GW",
      persianName: "گینه بیسائو",
    },
    { name: "Guyana", code: "GY", persianName: "گویانا" },
    { name: "Haiti", code: "HT", persianName: "هاییتی" },
    { name: "Honduras", code: "HN", persianName: "هندوراس" },
    { name: "Hungary", code: "HU", persianName: "مجارستان" },
    { name: "Iceland", code: "IS", persianName: "ایسلند" },
    { name: "India", code: "IN", persianName: "هند" },
    { name: "Indonesia", code: "ID", persianName: "اندونزی" },
    { name: "Iran", code: "IR", persianName: "ایران" },
    { name: "Iraq", code: "IQ", persianName: "عراق" },
    { name: "Ireland", code: "IE", persianName: "ایرلند" },
    { name: "Israel", code: "IL", persianName: "اسرائیل" },
    { name: "Italy", code: "IT", persianName: "ایتالیا" },
    { name: "Jamaica", code: "JM", persianName: "جامائیکا" },
    { name: "Japan", code: "JP", persianName: "ژاپن" },
    { name: "Jordan", code: "JO", persianName: "اردن" },
    { name: "Kazakhstan", code: "KZ", persianName: "قزاقستان" },
    { name: "Kenya", code: "KE", persianName: "کنیا" },
    { name: "Kiribati", code: "KI", persianName: "کیریباتی" },
    { name: "Kuwait", code: "KW", persianName: "کویت" },
    { name: "Kyrgyzstan", code: "KG", persianName: "قرقیزستان" },
    { name: "Laos", code: "LA", persianName: "لائوس" },
    { name: "Latvia", code: "LV", persianName: "لتونی" },
    { name: "Lebanon", code: "LB", persianName: "لبنان" },
    { name: "Lesotho", code: "LS", persianName: "لسوتو" },
    { name: "Liberia", code: "LR", persianName: "لیبریا" },
    { name: "Libya", code: "LY", persianName: "لیبی" },
    {
      name: "Liechtenstein",
      code: "LI",
      persianName: "لیختن‌اشتاین",
    },
    { name: "Lithuania", code: "LT", persianName: "لیتوانی" },
    { name: "Luxembourg", code: "LU", persianName: "لوکزامبورگ" },
    { name: "Madagascar", code: "MG", persianName: "ماداگاسکار" },
    { name: "Malawi", code: "MW", persianName: "مالاوی" },
    { name: "Malaysia", code: "MY", persianName: "مالزی" },
    { name: "Maldives", code: "MV", persianName: "مالدیو" },
    { name: "Mali", code: "ML", persianName: "مالی" },
    { name: "Malta", code: "MT", persianName: "مالت" },
    {
      name: "Marshall Islands",
      code: "MH",
      persianName: "جزایر مارشال",
    },
    { name: "Mauritania", code: "MR", persianName: "موریتانی" },
    { name: "Mauritius", code: "MU", persianName: "موریس" },
    { name: "Mexico", code: "MX", persianName: "مکزیک" },
    { name: "Micronesia", code: "FM", persianName: "میکرونزی" },
    { name: "Moldova", code: "MD", persianName: "مولداوی" },
    { name: "Monaco", code: "MC", persianName: "موناکو" },
    { name: "Mongolia", code: "MN", persianName: "مغولستان" },
    { name: "Montenegro", code: "ME", persianName: "مونته‌نگرو" },
    { name: "Morocco", code: "MA", persianName: "مراکش" },
    { name: "Mozambique", code: "MZ", persianName: "موزامبیک" },
    { name: "Myanmar", code: "MM", persianName: "میانمار" },
    { name: "Namibia", code: "NA", persianName: "نامیبیا" },
    { name: "Nauru", code: "NR", persianName: "نائورو" },
    { name: "Nepal", code: "NP", persianName: "نپال" },
    { name: "Netherlands", code: "NL", persianName: "هلند" },
    { name: "New Zealand", code: "NZ", persianName: "نیوزیلند" },
    { name: "Nicaragua", code: "NI", persianName: "نیکاراگوئه" },
    { name: "Niger", code: "NE", persianName: "نیجر" },
    { name: "Nigeria", code: "NG", persianName: "نیجریه" },
    {
      name: "North Korea",
      code: "KP",
      persianName: "کره شمالی",
    },
    {
      name: "North Macedonia",
      code: "MK",
      persianName: "مقدونیه شمالی",
    },
    { name: "Norway", code: "NO", persianName: "نروژ" },
    { name: "Oman", code: "OM", persianName: "عمان" },
    { name: "Pakistan", code: "PK", persianName: "پاکستان" },
    { name: "Palau", code: "PW", persianName: "پالائو" },
    { name: "Palestine", code: "PS", persianName: "فلسطین" },
    { name: "Panama", code: "PA", persianName: "پاناما" },
    {
      name: "Papua New Guinea",
      code: "PG",
      persianName: "پاپوآ گینه نو",
    },
    { name: "Paraguay", code: "PY", persianName: "پاراگوئه" },
    { name: "Peru", code: "PE", persianName: "پرو" },
    { name: "Philippines", code: "PH", persianName: "فیلیپین" },
    { name: "Poland", code: "PL", persianName: "لهستان" },
    { name: "Portugal", code: "PT", persianName: "پرتغال" },
    { name: "Qatar", code: "QA", persianName: "قطر" },
    { name: "Romania", code: "RO", persianName: "رومانی" },
    { name: "Russia", code: "RU", persianName: "روسیه" },
    { name: "Rwanda", code: "RW", persianName: "رواندا" },
    {
      name: "Saint Kitts and Nevis",
      code: "KN",
      persianName: "سنت کیتس و نویس",
    },
    { name: "Saint Lucia", code: "LC", persianName: "سنت لوسیا" },
    {
      name: "Saint Vincent and the Grenadines",
      code: "VC",
      persianName: "سنت وینسنت و گرنادین‌ها",
    },
    { name: "Samoa", code: "WS", persianName: "ساموآ" },
    { name: "San Marino", code: "SM", persianName: "سان مارینو" },
    {
      name: "Sao Tome and Principe",
      code: "ST",
      persianName: "سائو تومه و پرینسیپ",
    },
    {
      name: "Saudi Arabia",
      code: "SA",
      persianName: "عربستان سعودی",
    },
    { name: "Senegal", code: "SN", persianName: "سنگال" },
    { name: "Serbia", code: "RS", persianName: "صربستان" },
    { name: "Seychelles", code: "SC", persianName: "سیشل" },
    {
      name: "Sierra Leone",
      code: "SL",
      persianName: "سیرالئون",
    },
    { name: "Singapore", code: "SG", persianName: "سنگاپور" },
    { name: "Slovakia", code: "SK", persianName: "اسلواکی" },
    { name: "Slovenia", code: "SI", persianName: "اسلوونی" },
    {
      name: "Solomon Islands",
      code: "SB",
      persianName: "جزایر سلیمان",
    },
    { name: "Somalia", code: "SO", persianName: "سومالی" },
    {
      name: "South Africa",
      code: "ZA",
      persianName: "آفریقای جنوبی",
    },
    {
      name: "South Korea",
      code: "KR",
      persianName: "کره جنوبی",
    },
    {
      name: "South Sudan",
      code: "SS",
      persianName: "سودان جنوبی",
    },
    { name: "Spain", code: "ES", persianName: "اسپانیا" },
    { name: "Sri Lanka", code: "LK", persianName: "سریلانکا" },
    { name: "Sudan", code: "SD", persianName: "سودان" },
    { name: "Suriname", code: "SR", persianName: "سورینام" },
    { name: "Sweden", code: "SE", persianName: "سوئد" },
    { name: "Switzerland", code: "CH", persianName: "سوئیس" },
    { name: "Syria", code: "SY", persianName: "سوریه" },
    { name: "Taiwan", code: "TW", persianName: "تایوان" },
    { name: "Tajikistan", code: "TJ", persianName: "تاجیکستان" },
    { name: "Tanzania", code: "TZ", persianName: "تنزانیه" },
    { name: "Thailand", code: "TH", persianName: "تایلند" },
    {
      name: "Timor-Leste",
      code: "TL",
      persianName: "تیمور-لسته",
    },
    { name: "Togo", code: "TG", persianName: "توگو" },
    { name: "Tonga", code: "TO", persianName: "تونگا" },
    {
      name: "Trinidad and Tobago",
      code: "TT",
      persianName: "ترینیداد و توباگو",
    },
    { name: "Tunisia", code: "TN", persianName: "تونس" },
    { name: "Turkey", code: "TR", persianName: "ترکیه" },
    {
      name: "Turkmenistan",
      code: "TM",
      persianName: "ترکمنستان",
    },
    { name: "Tuvalu", code: "TV", persianName: "تووالو" },
    { name: "Uganda", code: "UG", persianName: "اوگاندا" },
    { name: "Ukraine", code: "UA", persianName: "اوکراین" },
    {
      name: "United Arab Emirates",
      code: "AE",
      persianName: "امارات متحده عربی",
    },
    { name: "United Kingdom", code: "GB", persianName: "بریتانیا" },
    {
      name: "United States",
      code: "US",
      persianName: "ایالات متحده آمریکا",
    },
    { name: "Uruguay", code: "UY", persianName: "اوروگوئه" },
    { name: "Uzbekistan", code: "UZ", persianName: "ازبکستان" },
    { name: "Vanuatu", code: "VU", persianName: "وانواتو" },
    { name: "Vatican City", code: "VA", persianName: "واتیکان" },
    { name: "Venezuela", code: "VE", persianName: "ونزوئلا" },
    { name: "Vietnam", code: "VN", persianName: "ویتنام" },
    { name: "Yemen", code: "YE", persianName: "یمن" },
    { name: "Zambia", code: "ZM", persianName: "زامبیا" },
    { name: "Zimbabwe", code: "ZW", persianName: "زیمبابوه" },
  ];
  